<header></header>
<div class="post-login-1">
  <div class="post-login-1-col-1 h-100">
    <left-panel activeTab="1"></left-panel>

  </div>
  <div class="post-login-1-col-2">
    <div class="discover-box bg-transparent pd">
      <grid-row class="justify-content-between align-item-center">
        <grid-col col="6" mobile="12">
          <div *ngIf="this.serviceType === 'Islamic'" class="profile-name bg-islamic">
            <div class="font-400 font-size-20px line-h-25 color-base-500">
              {{ "Hello" | translate }}
            </div>
            <div class="font-500 font-size-24px line-h-32">
              {{this.auth?.detailuser?.firstName}} {{this.auth?.detailuser?.lastName}}
            </div>
          </div>
          <div *ngIf="this.serviceType === 'Conventional'">
            <div class="font-400 font-size-20px line-h-25 color-base-500">
              {{ "Hello" | translate }}
            </div>
            <div class="font-500 font-size-24px line-h-32">
              {{this.auth?.detailuser?.firstName}} {{this.auth?.detailuser?.lastName}}
            </div>
          </div>

        </grid-col>
        <grid-col col="auto" mobile="12">
          <grid-row class="justify-content-between align-item-center col-space">
            <!-- <grid-col col="auto" *ngIf="this.LoyaltyCards && this.LoyaltyCards?.length > 0">
              <div class="br-40 pt-15 pb-15 pl-24 pr-24 box-shadow bg-linear-gradient link" [routerLink]="['/LoyaltyPoints']">
                <ng-icon iconClass="icon-gift-box mr-10" width="24" height="24"></ng-icon>
                <strong class="font-size-16px color-base-100 font-600">{{this.loyalityPoints}} Pts</strong>
              </div>
            </grid-col> -->
            <grid-col col="auto" mobile="12">
              <div class="toggle-box">
                <div class="toggle-box-item" [ngClass]="activeTab1 == 1 ? 'active' : ''" (click)="changeTab1(1)">
                  <ng-icon iconClass="icon-islamic-switch v-align-middle background-size-100" width="20"
                    height="20"></ng-icon>
                </div>
                <div class="toggle-box-item br-r" [ngClass]="activeTab1 == 2 ? 'active' : ''" (click)="changeTab1(2)">
                  <ng-icon iconClass="icon-sahel-gray v-align-middle background-size-100" width="20"
                    height="20"></ng-icon>

                </div>
              </div>
            </grid-col>
            <grid-col col="auto">
              <div class="custom-tab pr-20  pr-mobile-0">
                <div class="custom-tab-item" [ngClass]="activeTab == 2 ? 'active' : ''" (click)="changeTab(2)">
                  {{"EN" | translate}}
                </div>
                <div class="custom-tab-item" [ngClass]="activeTab == 1 ? 'active' : ''" (click)="changeTab(1)">
                  {{"AR" | translate}}
                </div>
              </div>
            </grid-col>
            <grid-col col="auto">
              <div class="profile-box">
                <div class="profile-box-img">
                  <!-- <img src="~/../assets/theme/component-icons/profile.svg" alt=""> -->
                  <img [src]="this.url" alt="profilePicture" *ngIf="this.url != null && this.url != ''">
                  <div *ngIf="this.url==null" class="color-base-1300 font-600 font-size-20px">
                    {{this.auth?.detailuser?.firstName.charAt(0).toLocaleUpperCase()+this.auth?.detailuser?.lastName.charAt(0).toLocaleUpperCase()}}
                  </div>
                </div>
              </div>
            </grid-col>
          </grid-row>
        </grid-col>
      </grid-row>

      <!-- <div class="p-24 bg-base-100 br-12 box-shadow mt-30">
       <grid-row class="justify-content-between">
        <grid-col col="auto">
          <div class="font-400 font-size-14px line-h-20 color-base-500">
            {{"WeeklySpending"| translate }}
          </div>
          <div class="font-600 font-size-20px line-h-25 mt-4">
            <span class="mr-5">
              {{"BHD" | translate}}
            </span>
            <span>50.250</span>
          </div>
          <grid-row class="align-item-center mt-24">
            <grid-col col="auto">
              <span>
                <ng-icon iconClass="icon-transport" width="24" height="24"></ng-icon> 
              </span>
            </grid-col>
            <grid-col col="auto">
              <span class="font-400 font-size-14px line-h-20 color-base-500 ml-7">
                {{"Transporting"| translate }}
              </span>
            </grid-col>
          </grid-row>
        </grid-col>
        <grid-col col="auto">
          <img src="~/../assets/images/graph-img.jpg" alt="">
        </grid-col>
      </grid-row>
      </div> -->




      <!-- Rewards Screen hide for now  078-02-24-->

      <div class="dashboard-card-sec mt-40 link">
        <div *ngIf="this.LoyaltyCards && this.LoyaltyCards?.length > 0">
          <div class="loyalty-box mt-15 mb-30" *ngFor="let L of this.LoyaltyCards" (click)="RewardsLoyaltyPoints()">
            <grid-row class="col-space">
              <grid-col col="auto">
                <ng-icon iconClass="icon-gift" width="60" height="60"></ng-icon>
              </grid-col>
              <grid-col col="auto">
                <div>
                  <strong class="mr-5 font-600 font-size-24px line-h-32">
                    <!-- 450,383 -->{{L.rewardsBalance }}
                  </strong>
                  <span>
                    {{"LoyaltyPoints" | translate}}
                  </span>
                </div>
                <div class="mt-5">
                  <span class="mr-5">
                    {{L.pointsExpiringInNextMonth}}
                  </span>
                  <span>
                    {{"pointsare" | translate}}
                  </span>
                </div>
              </grid-col>
            </grid-row>
          </div>
        </div>

        <!-- Quick Actions - new mobile-style action chips -->
        <!-- <app-quick-actions></app-quick-actions> -->

        <!-- Due Soon Payments - upcoming payments carousel -->
        <!-- <app-due-soon-payments
          [cardDetails]="cardDetail"
          [loanDetails]="loanDetail">
        </app-due-soon-payments> -->

        <div class="font-400 font-size-14px line-h-20 color-base-500"
          *ngIf="this.account.CheckVstStatus != undefined && this.ticketID != '' && this.ticketnumber != ''">
          {{ "PENDINGQUEUE" | translate }}

          <div class="br-12 box-shadow-4 p-24 bg-2200-lines color-base-100 mt-10"
            *ngFor="let c of this.account.CheckVstStatus">
            <grid-row class="justify-content-between">
              <grid-col col="auto">
                
                <div>
                  <span class="font-400 br-40 color-base-100 font-size-11px bg-base-2200 pt-5 pb-5 pr-10 pl-10">
                    {{ "VirtualTicket" | translate }}
                  </span>
                </div>
              </grid-col>
              <grid-col col="auto">
                <div class="font-600 color-base-2200 font-size-16px border-bottom border-color-2200">
                  <!-- {{this.ticketnumber}} -->
                  {{c.ticketId}}
                </div>
                <div class="font-400 color-base-2200 font-size-10px mt-2 text-align-right">
                  {{ "TicketNo" | translate }}
                </div>
              </grid-col>
            </grid-row>

            <div class="font-400 color-base-2200 font-size-12px mt-15">
              <span class="mr-5">
                {{ "InQueue" | translate }}
              </span>
              <strong class="font-600">
                <!-- 3 Customers -->{{c.queueSize}} ><span>{{"Customers" | translate}}</span>
              </strong>
            </div>
            <div class="font-400 color-base-2200 font-size-12px mt-5">
              <span class="mr-5">
                {{ "BankBranch" | translate }}
              </span>
              <strong class="font-600">
                <!-- Seef Muharraq Mall (Consumer Finance) -->
                {{c.branchName}} &nbsp; <span>( {{c.currentServiceName}} )</span>
              </strong>
            </div>
          </div>

        </div>
        <!--  yousuf insuranceDetails-->
        <!-- <div class="font-400 font-size-14px line-h-20 color-base-500 mt-25" *ngIf="
        pendingApplication.insuranceDetails?.length > 0 || 
        pendingApplication.cardDetails?.length > 0 || 
        pendingApplication.loanDetails?.length > 0 || 
        pendingApplication.prePaidCardDetails?.length > 0
      "> -->
        <div *ngIf="this.serviceType === 'Conventional'">
          <div class="font-400 font-size-14px line-h-20 color-base-500 mb-25" *ngIf="
  (pendingApplication.insuranceDetails?.length > 0 && pendingApplication.insuranceDetails[0]?.bcfcStatus !== 'Complete') || 
  (pendingApplication.cardDetails?.length > 0 && pendingApplication.cardDetails[0]?.bcfcStatus !== 'Complete') || 
  (pendingApplication.loanDetails?.length > 0 && pendingApplication.loanDetails[0]?.bcfcStatus !== 'Complete') || 
  (pendingApplication.prePaidCardDetails?.length > 0 && pendingApplication.prePaidCardDetails[0]?.bcfcStatus !== 'Complete')
">
            {{ "ONGOINGAPPLICATION" | translate }}

            <!-- insurance -->
            <div *ngFor="let item of pendingApplication.insuranceDetails">
              <div *ngIf="item?.bcfcStatus !== 'Complete'" class="ongoing-card mt-15">
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <!-- <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15" *ngIf="item.underReview === 'Y'">
               In Process
              </span> -->
                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15">
                      {{ item.underReview === 'Y' ? 'Under Review' : 'In Process' }}
                    </span>
                  </grid-col>
                  <grid-col col="auto">
                    <span class="font-400 br-40 color-base-2200 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      <!-- {{ item.productName }} -->
                      {{ "INSURANCE" | translate }}
                    </span>
                  </grid-col>
                </grid-row>

                <div class="mt-15 font-size-16px font-400 letter-spacing-1 color-base-100">
                  {{ item.packageName }}
                </div>

                <grid-row class="justify-content-between align-item-center mt-15">
                  <grid-col col="auto">
                    <span class="font-size-12px pr-10">{{ "RefID" | translate }}</span>
                    <strong class="font-size-12px font-600">
                      {{ item.proposalId }}
                    </strong>
                  </grid-col>
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">last edit</span> -->
                    <strong class="font-size-12px font-600">
                      <!-- {{ item.preInfoAddedDate }} -->
                      <!-- {{ item.preInfoAddedDate | date: 'shortTime' }} -->
                      {{ item.entryCreatedOn | date: 'MM/dd/yyyy, h:mm a' }}

                    </strong>
                  </grid-col>
                </grid-row>
              </div>
            </div>


            <!--  cardDetails -->

            <div *ngFor="let item of pendingApplication.cardDetails">
              <div *ngIf="item?.bcfcStatus !== 'Complete'" class="ongoing-card mt-15">
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <!-- <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                  *ngIf="item.underReview === 'Y'">
                  In Process
                </span> -->
                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === '' || item.flowType === null">
                      {{ "InProcess" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'AMBER' && item.resubmitAmber === 'NO'">
                      {{ "InReview" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-success pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'GREEN' && item.resubmitAmber === 'YES'">
                      {{ "Reviewed" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-secondary pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'GREEN' && item.resubmitAmber === 'NO'">
                      {{ "Pending" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-secondary pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType !== 'AMBER' && item.flowType !== 'GREEN' && item.flowType !== '' && item.flowType !== null">
                      {{ "Pending" | translate }}
                    </span>

                  </grid-col>
                  <grid-col col="auto">
                    <span class="font-400 br-40 color-base-2200 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      <!-- {{ item.productName }} -->
                      {{ "CARD" | translate }}
                    </span>
                  </grid-col>
                </grid-row>

                <div class="mt-15 font-size-16px font-400 letter-spacing-1 color-base-100">
                  {{ item.cardTypeName }}
                </div>

                <grid-row class="justify-content-between align-item-center mt-15">
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">Ref ID</span>
            <strong class="font-size-12px font-600">
              {{ item.proposalId }}
            </strong> -->
                  </grid-col>
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">last edit</span> -->
                    <strong class="font-size-12px font-600">
                      <!-- {{ item.preInfoAddedDate }} -->
                      <!-- {{ item.preInfoAddedDate | date: 'shortTime' }} -->
                      {{ item.entryCreatedOn | date: 'MM/dd/yyyy, h:mm a' }}

                    </strong>
                  </grid-col>
                </grid-row>
              </div>
            </div>


            <!--  loanDetails -->

            <div *ngFor="let item of pendingApplication.loanDetails">
              <div *ngIf="item?.bcfcStatus !== 'Complete'" class="ongoing-card mt-15">
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <!-- <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                  *ngIf="item.underReview === 'Y'">
                  In Process
                </span> -->
                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === '' || item.flowType === null">
                      {{ "InProcess" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'AMBER' && item.resubmitAmber === 'NO'">
                      {{ "InReview" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-success pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'GREEN' && item.resubmitAmber === 'YES'">
                      {{ "Reviewed" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-secondary pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'GREEN' && item.resubmitAmber === 'NO'">
                      {{ "Pending" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-secondary pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType !== 'AMBER' && item.flowType !== 'GREEN' && item.flowType !== '' && item.flowType !== null">
                      {{ "Pending" | translate }}
                    </span>

                  </grid-col>
                  <grid-col col="auto">
                    <span class="font-400 br-40 color-base-2200 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      <!-- {{ item.productName }} -->
                      {{ "LOAN" | translate }}
                    </span>
                  </grid-col>
                </grid-row>

                <div class="mt-15 font-size-16px font-400 letter-spacing-1 color-base-100">
                  {{ item.productName }}
                </div>

                <grid-row class="justify-content-between align-item-center mt-15">
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">Ref ID</span>
          <strong class="font-size-12px font-600">
            {{ item.proposalId }}
          </strong> -->
                  </grid-col>
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">last edit</span> -->
                    <strong class="font-size-12px font-600">
                      <!-- {{ item.preInfoAddedDate }} -->
                      <!-- {{ item.preInfoAddedDate | date: 'shortTime' }} -->
                      {{ item.createdOn | date: 'MM/dd/yyyy, h:mm a' }}

                    </strong>
                  </grid-col>
                </grid-row>
              </div>
            </div>


            <!--  prePaidCardDetails -->

            <div *ngFor="let item of pendingApplication.prePaidCardDetails">
              <div *ngIf="item?.bcfcStatus !== 'Complete'" class="ongoing-card mt-15">
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <!-- <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15" *ngIf="item.flowType === ''">
         In Process
        </span> -->
                    <span class="font-400 br-40 color-base-100 font-size-12px bg-warning pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === ''">
                      {{ "InProcess" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-danger pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'RED'">
                      {{ "Expired" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-success pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType === 'GREEN'">
                      {{ "Reviewed" | translate }}
                    </span>

                    <span class="font-400 br-40 color-base-100 font-size-12px bg-secondary pt-5 pb-5 pr-15 pl-15"
                      *ngIf="item.flowType !== '' && item.flowType !== 'RED' && item.flowType !== 'GREEN'">
                      {{ "Pending" | translate }}
                    </span>


                  </grid-col>
                  <grid-col col="auto">
                    <span class="font-400 br-40 color-base-2200 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      <!-- {{ item.productName }} -->
                      {{ "PREPAIDCARD" | translate }}
                    </span>
                  </grid-col>
                </grid-row>

                <div class="mt-15 font-size-16px font-400 letter-spacing-1 color-base-100">
                  {{ item.cardTypeName }}
                </div>

                <grid-row class="justify-content-between align-item-center mt-15">
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">Ref ID</span>
        <strong class="font-size-12px font-600">
          {{ item.proposalId }}
        </strong> -->
                  </grid-col>
                  <grid-col col="auto">
                    <!-- <span class="font-size-12px pr-10">last edit</span> -->
                    <strong class="font-size-12px font-600">
                      <!-- {{ item.preInfoAddedDate }} -->
                      <!-- {{ item.preInfoAddedDate | date: 'shortTime' }} -->
                      {{ item.entryCreatedOn | date: 'MM/dd/yyyy, h:mm a' }}

                    </strong>
                  </grid-col>
                </grid-row>
              </div>
            </div>

          </div>
        </div>


        <!-- Ticket no BCFC-888 Jira -->
        <div *ngIf="this.serviceType === 'Conventional'">
          <!-- <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1" *ngIf="this.cardDetail">
            {{ "UpcomingPayment" | translate }}
          </div> -->
          <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1"
           *ngIf="(cardDetail?.length > 0) || (loanDetail?.length > 0)">
           {{ 'UpcomingPayment' | translate }}
           </div>

          <!-- 🔹 CARD SECTION -->
          <div *ngIf="this.cardDetail && this.cardDetail.length > 0">
            <div *ngFor="let item of this.cardDetail; let i = index">
              <div class="pay-now-main mt-15" [ngClass]="payNowBtnStatus == i ? 'show-pay-now':''" *ngIf="item">
                <div class="col-1">
                  <div class="show-pay-button" (click)="showPayNowBtn(i)"></div>
                  <div class="show-detail-button" (click)="CardDash(item?.internalId,'Home')"></div>

                  <div class="br-12 box-shadow-4 p-24 color-base-100" [ngClass]="
            item?.productCode === '005' ? 'bg-mc-platinum' :
            item?.productCode === '004' ? 'bg-titanium color-base-3700' :
            item?.productCode === '007' ? 'bg-007' :
            item?.productCode === '028' ? 'bg-MCWH' :
            item?.productCode === '029' ? 'bg-MCWH' :
            item?.productCode === '001' ? 'bg-mc-world-elite' :
            item?.productCode === '002' ? 'bg-mc-world-elite' :
            item?.productCode === '003' ? 'bg-mc-world-elite' :
            item?.productCode === '006' ? 'bg-mc-world-elite' :
            item?.productCode === '008' ? 'bg-mc-world-elite' :
            item?.productCode === '009' ? 'bg-corp-exec-plat' :
            item?.productCode === '040' ? 'bg-mc-world-corp' :
            item?.productCode === '050' ? 'bg-unipal' :
            item?.productCode === '017' ? 'bg-mc-for-her-supp' :
            item?.productCode === '039' ? 'bg-mc-for-her-gift' :
            item?.productCode === '013' ? 'bg-mc-world' :
            item?.productCode === '016' ? 'bf-f91' :
            item?.productCode === '024' ? 'bg-mc-titanium-bt' :
            item?.productCode === '025' ? 'bg-mc-platinum-bt' :
            item?.productCode === '026' ? 'bg-mc-world-bt' :
            item?.productCode === '011' ? 'bg-mc-uefa' :
            item?.productCode === '027' ? 'bg-mc-for-her-pr-bt' :
            item?.productCode === '042' ? 'bg-platinum color-base-3600' :
            item?.productCode === '043' ? 'bg-co-brand-mastercard-world' :
            item?.productCode === '041' ? 'bg-co-brand-mastercard-world-elite' :
            'bg-default'
          ">
                    <div class="font-300 font-size-14px line-h-20">
                      {{ item?.cardCategory }}
                    </div>

                    <grid-row class="mt-20 justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div class="font-600 font-size-20px line-h-32">
                          <span class="mr-5">{{ item?.cardCurrencyISO | translate }}</span>
                          <span>{{ checkAmount(item?.minimumAmountDue) | amountFormatter }}</span>
                        </div>
                      </grid-col>
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px line-h-16">
                            {{ "PaymentDue" | translate }}
                          </span>
                          <span class="font-700 font-size-14px line-h-16">
                            {{ item?.paymentDueInDays }} {{ "Days" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>

                    <grid-row class="justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px">
                            {{ "MiniAmountDue" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>
                  </div>
                </div>

                <div class="col-2">
                  <div class="pay-now-btn" (click)="PayCard(item?.internalId,'C', item?.maxPaymentAmount)">
                    <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                    <div class="font-600 font-size-10px line-h-14 w-100 mt-5">
                      <div *ngIf="item.productCode === '050' || item.productCode === '007'">
                        {{ "TopUpCard" | translate }}
                      </div>
                      <div *ngIf="item.productCode !== '050' && item.productCode !== '007'">
                        {{ "PayNow" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 🔹 LOAN SECTION -->
          <div *ngIf="this.loanDetail && this.loanDetail.length > 0">
            <div *ngFor="let item of this.loanDetail">
              <div class="pay-now-main mt-20" *ngIf="item">
                <div class="col-1" (click)="LoanDash(item?.internalId,'Home')">
                  <div class="br-12 box-shadow-4 p-24 bg-color-base-2300 color-base-100">
                    <span class="font-400 br-40 color-base-1500 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      {{ item?.productDescription }}
                    </span>

                    <grid-row class="mt-20 justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div class="font-600 font-size-20px line-h-32">
                          <span class="mr-5">{{ item?.accountCurrencyISO }}</span>
                          <span>{{ item?.installmentAmount | amountFormatter }}</span>
                        </div>
                      </grid-col>
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px line-h-16">
                            {{ "PaymentDue" | translate }}
                          </span>
                          <span class="font-700 font-size-14px line-h-16">
                            {{ item?.paymentDueInDays }} {{ "Days" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>

                    <grid-row class="justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px">
                            {{ "AmountDue" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>
                  </div>
                </div>

                <div class="col-2">
                  <div class="pay-now-btn" (click)="PayCard(item?.internalId,'L', item?.maxPaymentAmount)">
                    <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                    <div class="font-600 font-size-10px line-h-14 w-100 mt-5">
                      {{ "PayNow" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- <div *ngFor="let item of this.InsuranceDetail">
          <div class="pay-now-main mt-20" *ngIf="this.InsuranceDetail">
            <div class="col-1">
              <div class="br-12 box-shadow-4 p-24 bg-color-base-2500 color-base-100">
                <span class="font-400 br-40 color-base-1500 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                  {{item?.productName}} Insurance
                </span>
                <grid-row class="mt-20 justify-content-between align-item-center">
                  <grid-col col="auto">
                    <div class="font-600 font-size-20px line-h-32">
                      <span class="mr-5">
                        {{item?.accountCurrencyISO}}
                      </span>
                      <span>{{item?.sumInsuredAmount | amountFormatter}}</span>
                    </div>
                  </grid-col>
                  <grid-col col="auto">
                    <div>
                      <span class="mr-5 font-400 font-size-14px line-h-16">
                        {{ "RenewelDue" | translate }}
                      </span>
                      <span class="font-700 font-size-14px line-h-16">
                        {{item?.paymentDueInDays}} {{ "Days" | translate }}</span>
                    </div>
                  </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <div>
                      <span class="mr-5 font-400 font-size-14px ">
                        {{ "AmountDue" | translate }}
                      </span>
                    </div>
                  </grid-col>
                </grid-row>
              </div>
            </div>
            <div class="col-2">
              <div class="box-shadow p-29 border border-color-900 text-align-center br-12 link"
                (click)="PayCard(item?.internalId,'L',item?.maxPaymentAmount)">
                <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                <div class="font-600 font-size-10px line-h-14 mt-12">
                  {{ "PayNow" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div> -->

          <!--  Ticket no BCFC-888 Jira -->
        </div>


        <!-- for islamic -->
        <div *ngIf="this.serviceType === 'Islamic'">
          <!-- <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1" *ngIf="this.cardDetail">
            {{ "UpcomingPayment" | translate }}
          </div> -->
          <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1"
           *ngIf="(cardDetail?.length > 0) || (loanDetail?.length > 0)">
           {{ 'UpcomingPayment' | translate }}
          </div>

          <!-- 🔹 CARD SECTION -->
          <div *ngIf="this.cardDetail && this.cardDetail.length > 0">
            <div *ngFor="let item of this.cardDetail; let i = index">
              <div class="pay-now-main mt-15" [ngClass]="payNowBtnStatus == i ? 'show-pay-now':''" *ngIf="item">
                <div class="col-1">
                  <div class="show-pay-button" (click)="showPayNowBtn(i)"></div>
                  <div class="show-detail-button" (click)="CardDash(item?.internalId,'Home')"></div>

                  <div class="br-12 box-shadow-4 p-24 color-base-100" [ngClass]="
            item?.productCode === '005' ? 'bg-mc-platinum' :
            item?.productCode === '004' ? 'bg-titanium color-base-3700' :
            item?.productCode === '007' ? 'bg-007' :
            item?.productCode === '028' ? 'bg-MCWH' :
            item?.productCode === '029' ? 'bg-MCWH' :
            item?.productCode === '001' ? 'bg-mc-world-elite' :
            item?.productCode === '002' ? 'bg-mc-world-elite' :
            item?.productCode === '003' ? 'bg-mc-world-elite' :
            item?.productCode === '006' ? 'bg-mc-world-elite' :
            item?.productCode === '008' ? 'bg-mc-world-elite' :
            item?.productCode === '009' ? 'bg-corp-exec-plat' :
            item?.productCode === '040' ? 'bg-mc-world-corp' :
            item?.productCode === '050' ? 'bg-unipal' :
            item?.productCode === '017' ? 'bg-mc-for-her-supp' :
            item?.productCode === '039' ? 'bg-mc-for-her-gift' :
            item?.productCode === '013' ? 'bg-mc-world' :
            item?.productCode === '016' ? 'bf-f91' :
            item?.productCode === '024' ? 'bg-mc-titanium-bt' :
            item?.productCode === '025' ? 'bg-mc-platinum-bt' :
            item?.productCode === '026' ? 'bg-mc-world-bt' :
            item?.productCode === '011' ? 'bg-mc-uefa' :
            item?.productCode === '027' ? 'bg-mc-for-her-pr-bt' :
            item?.productCode === '042' ? 'bg-platinum color-base-3600' :
            item?.productCode === '043' ? 'bg-co-brand-mastercard-world' :
            item?.productCode === '041' ? 'bg-co-brand-mastercard-world-elite' :
            'bg-default'
          ">
                    <div class="font-300 font-size-14px line-h-20">
                      {{ item?.cardCategory }}
                    </div>

                    <grid-row class="mt-20 justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div class="font-600 font-size-20px line-h-32">
                          <span class="mr-5">{{ item?.cardCurrencyISO | translate }}</span>
                          <span>{{ checkAmount(item?.minimumAmountDue) | amountFormatter }}</span>
                        </div>
                      </grid-col>
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px line-h-16">
                            {{ "PaymentDue" | translate }}
                          </span>
                          <span class="font-700 font-size-14px line-h-16">
                            {{ item?.paymentDueInDays }} {{ "Days" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>

                    <grid-row class="justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px">
                            {{ "MiniAmountDue" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>
                  </div>
                </div>

                <div class="col-2">
                  <div class="pay-now-btn" (click)="PayCard(item?.internalId,'C', item?.maxPaymentAmount)">
                    <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                    <div class="font-600 font-size-10px line-h-14 w-100 mt-5">
                      <div *ngIf="item.productCode === '050' || item.productCode === '007'">
                        {{ "TopUpCard" | translate }}
                      </div>
                      <div *ngIf="item.productCode !== '050' && item.productCode !== '007'">
                        {{ "PayNow" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 🔹 LOAN SECTION -->
          <div *ngIf="this.loanDetail && this.loanDetail.length > 0">
            <div *ngFor="let item of this.loanDetail">
              <div class="pay-now-main mt-20 mb-20" *ngIf="item">
                <div class="col-1" (click)="LoanDash(item?.internalId,'Home')">
                  <div class="br-12 box-shadow-4 p-24 bg-color-base-2300 color-base-100" [ngClass]="
            item?.productCode === 'L25' ? 'bg-islamic-l25' :
            item?.productCode === 'L26' ? 'bg-islamic-l26' :
            item?.productCode === 'L27' ? 'bg-islamic-l27' :
            'bg-default'
          ">
                    <span class="font-400 br-40 color-base-1500 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                      {{ item?.productDescription }}
                    </span>

                    <grid-row class="mt-20 justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div class="font-600 font-size-20px line-h-32">
                          <span class="mr-5">{{ item?.accountCurrencyISO }}</span>
                          <span>{{ item?.installmentAmount | amountFormatter }}</span>
                        </div>
                      </grid-col>
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px line-h-16">
                            {{ "PaymentDue" | translate }}
                          </span>
                          <span class="font-700 font-size-14px line-h-16">
                            {{ item?.paymentDueInDays }} {{ "Days" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>

                    <grid-row class="justify-content-between align-item-center">
                      <grid-col col="auto">
                        <div>
                          <span class="mr-5 font-400 font-size-14px">
                            {{ "AmountDue" | translate }}
                          </span>
                        </div>
                      </grid-col>
                    </grid-row>
                  </div>
                </div>

                <div class="col-2">
                  <div class="pay-now-btn" (click)="PayCard(item?.internalId,'L', item?.maxPaymentAmount)">
                    <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                    <div class="font-600 font-size-10px line-h-14 w-100 mt-5">
                      {{ "PayNow" | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!-- <div *ngFor="let item of this.InsuranceDetail">
          <div class="pay-now-main mt-20" *ngIf="this.InsuranceDetail">
            <div class="col-1">
              <div class="br-12 box-shadow-4 p-24 bg-color-base-2500 color-base-100">
                <span class="font-400 br-40 color-base-1500 font-size-12px bg-base-100 pt-5 pb-5 pr-15 pl-15">
                  {{item?.productName}} Insurance
                </span>
                <grid-row class="mt-20 justify-content-between align-item-center">
                  <grid-col col="auto">
                    <div class="font-600 font-size-20px line-h-32">
                      <span class="mr-5">
                        {{item?.accountCurrencyISO}}
                      </span>
                      <span>{{item?.sumInsuredAmount | amountFormatter}}</span>
                    </div>
                  </grid-col>
                  <grid-col col="auto">
                    <div>
                      <span class="mr-5 font-400 font-size-14px line-h-16">
                        {{ "RenewelDue" | translate }}
                      </span>
                      <span class="font-700 font-size-14px line-h-16">
                        {{item?.paymentDueInDays}} {{ "Days" | translate }}</span>
                    </div>
                  </grid-col>
                </grid-row>
                <grid-row class="justify-content-between align-item-center">
                  <grid-col col="auto">
                    <div>
                      <span class="mr-5 font-400 font-size-14px ">
                        {{ "AmountDue" | translate }}
                      </span>
                    </div>
                  </grid-col>
                </grid-row>
              </div>
            </div>
            <div class="col-2">
              <div class="box-shadow p-29 border border-color-900 text-align-center br-12 link"
                (click)="PayCard(item?.internalId,'L',item?.maxPaymentAmount)">
                <ng-icon iconClass="icon-pay-card-green" width="30" height="24"></ng-icon>
                <div class="font-600 font-size-10px line-h-14 mt-12">
                  {{ "PayNow" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div> -->

          <!--  Ticket no BCFC-888 Jira -->
          <grid-row>
            <!-- (click)="redirectToInsurancePage()" -->
            <grid-col>
              <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
                {{ "IslamicPersonalFinance" | translate }}
              </div>
              <div class="deal-card">
                <div class="card-img">
                  <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                  <!-- <img src="~/../assets/images/explore-card-loan-img.png" alt=""> -->
                  <img class="border-none" src="~/../assets/images/islamic-finance.png" alt="">
                </div>
                <div class="content-box min-h-110 bg-color-base-2400">
                  <div class="font-700 font-size-14px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                    {{"ExploreourIslamicfinance" | translate}}
                  </div>
                  <div class="font-400 font-size-14px line-h-20 color-base-2800 mt-5">
                    {{"Getyourfirstcard" | translate}}
                  </div>
                </div>
              </div>
            </grid-col>

          </grid-row>
        </div>
        <!-- islamic end -->





        <!-- <grid-row>
        <grid-col col="6" mobile="12">
          <div class="font-600 font-size-32px line-h-40 letter-spacing-03">
            {{"DiscoverOffersProduct" | translate }}
          </div>
        </grid-col>
      </grid-row> -->
        <!-- <div class="img-box">
        <img src="~/../assets/images/offer-banner-img.png" alt="">
        <div class="text-box">
          <div class="font-600 font-size-20px line-h-32 color-base-100">
            {{"BannerText" | translate }}
          </div>
          <grid-row class="mt-25">
            <grid-col col="auto">
              <ng-icon iconClass="icon-heart-white" width="18" height="16"></ng-icon>
              <ng-icon iconClass="icon-heart-active" width="18" height="25"></ng-icon>
              <span class="font-500 font-size-12px line-h-18 color-base-100 ml-5">
                2356
              </span>
            </grid-col>
          </grid-row>
        </div>
      </div> -->

        <div *ngIf="this.serviceType === 'Conventional'" class="mt-40">
          <grid-row class="col-space-min">
            <grid-col col="6" mobile="12" (click)="redirectToLoanPage()">
              <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
                {{ "PersonalLoan" | translate }}
              </div>
              <div class="deal-card ">
                <div class="card-img">
                  <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                  <img src="~/../assets/images/Dashborad1.png" alt="">
                </div>
                <div class="content-box min-h-110 bg-color-base-2400">
                  <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                    {{"PLoanTitile" | translate}}
                  </div>
                  <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                    {{"PersonalLoanDes" | translate}}
                  </div>
                </div>
              </div>
            </grid-col>
            <grid-col col="6" mobile="12" class="mt-mobile-15" (click)="redirectToCarPage()">
              <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
                {{ "CarLoan" | translate }}
              </div>
              <div class="deal-card ">
                <div class="card-img">
                  <img src="~/../assets/images/Loan_Inner_Banner-Car.png" alt="">

                </div>
                <div class="content-box min-h-110 bg-color-base-2900">
                  <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                    {{"ExploreCARLOANS" | translate}}
                  </div>
                  <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                    {{"AffordablePersonalLoans" | translate}}
                  </div>

                </div>
              </div>
            </grid-col>

          </grid-row>
          <grid-row class="col-space-min mt-40 mt-mobile-15">
            <grid-col col="6" mobile="12" class="mt-mobile-15" (click)="redirectToCardsPage()">
              <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
                {{ "CardsForYOu" | translate }}
              </div>
              <div class="deal-card ">
                <div class="card-img">
                  <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                  <img src="~/../assets/images/imtiaz-banner.png" alt="">
                </div>
                <div class="content-box min-h-110 bg-color-base-2900">
                  <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                    {{"imtiazCreditCard" | translate}}
                  </div>
                  <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                    {{"GetFirstCard" | translate}}
                  </div>

                </div>
              </div>
            </grid-col>
            <!-- <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
              {{ "imtiazCreditCard" | translate }}
            </div>
            <div class="deal-card">
              <div class="card-img">
                <img src="~/../assets/images/DashboardCard.png" alt="">
              </div>
              <div class="content-box min-h-110 bg-color-base-2900">
                // <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                 // {{"ExploreCreditCards" | translate}}
                //</div> 
                <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                  {{"GetFirstCard" | translate}}
                </div>

              </div>
            </div>
          </grid-col> -->
            <grid-col col="6" mobile="12" class="mt-mobile-15" (click)="redirectToInsurancePage()">
              <div class="font-700 font-size-14px line-h-20 color-base-1500 letter-spacing-1 text-uppercase mb-16">
                {{ "insurance" | translate }}
              </div>
              <div class="deal-card ">
                <div class="card-img">
                  <!-- <img src="~/../assets/images/deal-1-card-img.png" alt=""> -->
                  <!-- <img src="~/../assets/images/explore-card-loan-img.png" alt=""> -->
                  <img src="~/../assets/images/DashboardInsurance.png" alt="">
                </div>
                <div class="content-box min-h-110 bg-color-base-2400">
                  <!-- <div class="font-700 font-size-10px line-h-22 color-base-1500 letter-spacing-1 text-uppercase mt-10">
                  {{"ExploreOurPersonalLoan" | translate}}
                </div> -->
                  <div class="font-400 font-size-14px line-h-20 color-base-2800 letter-spacing-2 mt-5">
                    {{"InsuranceDes" | translate}}
                  </div>
                </div>
              </div>
            </grid-col>
          </grid-row>
        </div>

        <grid-row class="col-space-min align-item-center mt-50 mb-50" *ngIf="this.serviceType === 'Conventional'">
          <grid-col col="6" mobile="12" class="mt-mobile-15">
            <div class="br-16 bg-color-base-2400">
              <grid-row class="align-item-center">
                <grid-col col="4" ipad="4">
                  <ng-icon iconClass="icon-card-girl v-align-middle bl-16-16" width="130" height="96"></ng-icon>
                </grid-col>
                <grid-col col="8">
                  <div class="font-400 font-size-12px letter-spacing-1 line-h-20 color-base-2200 p-16">
                    {{ "GetSpecialOffersIMTIAZ" | translate }}
                  </div>
                </grid-col>
              </grid-row>
            </div>
          </grid-col>
        </grid-row>

      </div>
    </div>
    <!-- <div class="post-login-1-col-3">
    <div class="pl-20 pr-20">
      <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
        {{"Sponsored" | translate }}
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/sponsor-card-img.png" alt="">
        </div>
        <div class="content-box">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedCashExtra" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"Applyourproduct" | translate }}
          </div>
        </div>
      </div>
      <div class="deal-card pt-10 pb-10">
        <div class="card-img">
          <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
        </div>
        <div class="content-box bg-2900">
          <div class="font-600 font-size-14px line-h-20 color-base-1500">
            {{"NeedMedicalInsurance" | translate }}
          </div>
          <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
            {{"GetYourFamilyMedical" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
  </div>


  <modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="Yes"
    [whiteButtonStatus]="true" whiteButtonText="No">
    <div class="text-align-center">
      <div class="mt-15 font-600 font-size-20px line-h-25 color-base-1300">
        {{ "Refreshtoken" | translate }}
      </div>
      <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
        {{ "Yoursessionisabout" | translate }}
      </div>
      <div class="font-600 font-size-26px color-base-1300">
        {{ "12:12" | translate }}
      </div>
    </div>
  </modal>